import styled from 'styled-components';

const SCell = styled.span`
  width: 100%;
  display: block;
  background-color: ${(props) =>
    props.isInactive ? props.theme.palette.colors.gray100 : props.theme.palette.colors.white};
  border-right: 1px solid #ddd;

  &:first-child {
    border-left: 1px solid #ddd;
  }
`;

const SHeader = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${(props) =>
    props.isCurrentDate
      ? props.theme.palette.warning.main
      : props.isOffRange
      ? props.theme.palette.colors.gray300
      : props.theme.palette.text.primary};
`;

export { SCell, SHeader };
